<section class="package-selection">
  <app-shipment-stepper [activeStepIndex]="activeStepIndex" />

  <div
    class="package-selection__content"
    [attr.aria-busy]="showPackageSkeleton() || catalogPending() ? 'true' : null"
  >
    @if (showPackageSkeleton()) {
      <output class="package-selection__loading-status visually-hidden">
        {{ 'createShipment.packageStep.catalogLoading' | translate }}
      </output>
      <app-package-selection-skeleton />
    } @else if (!catalogPending()) {
      @if (packageCatalogLoadFailed()) {
        <app-alert-toast
          class="package-selection__catalog-error"
          severity="error"
          live="assertive"
          [message]="'createShipment.packageStep.details.catalogLoadError' | translate"
        />
      }

      @if (accountLookupError()) {
        <app-alert-toast
          class="package-selection__account-error"
          severity="error"
          live="assertive"
          [message]="accountLookupError()! | translate"
        />
      }

      <app-package-type-selector
        [packageTypes]="visiblePackageTypes()"
        [selectedId]="selectedPackageTypeId()"
        (packageTypeChange)="onPackageTypeChange($event)"
        (howToMeasureRequested)="openMeasureDialog()"
      >
        @if (selectedRequiresDimensions() && effectiveSelectedConstraints(); as constraints) {
          <app-customer-packaging-details
            packageDetailsSlot
            [pieces]="form.controls.pieces"
            [pieceCount]="packagePieceCount()"
            [pieceRowViewKeys]="pieceRowViewKeys()"
            [unitSystem]="unitSystem()"
            [constraints]="constraints"
            [showValidationErrors]="showValidationErrors()"
            [bannerErrors]="customerBannerErrors()"
            [weightLimitParams]="customerMaxWeightParams()"
            [lengthLimitParams]="customerMaxLengthParams()"
            [destinationResidential]="isDestinationResidential()"
            (unitSystemChange)="onUnitSystemChange($event)"
            (addPackage)="onAddPackage()"
            (clearRow)="onClearRow($event)"
            (removeRow)="onRemoveRow($event)"
          />
        } @else if (selectedPackageType(); as selected) {
          <app-express-packaging-details
            packageDetailsSlot
            [packageTypeCode]="selected.id"
            [constraints]="effectiveSelectedConstraints() ?? selected.constraints"
            [dimensions]="selected.dimensions"
            [idealFor]="selected.idealFor"
            [expressTotalWeight]="form.controls.expressTotalWeight"
            [expressRequiresAdditionalHandling]="form.controls.expressRequiresAdditionalHandling"
            [unitSystem]="unitSystem()"
            [showValidationErrors]="showValidationErrors()"
            (unitSystemChange)="onUnitSystemChange($event)"
          />
        }
      </app-package-type-selector>

      <app-tracking-references-section
        [trackingReferences]="form.controls.trackingReferences"
        [showValidationErrors]="showValidationErrors()"
      />

      <app-delivery-instructions-section
        [control]="form.controls.deliveryInstructions"
        [showValidationErrors]="showValidationErrors()"
      />

      <app-package-selection-actions
        [loading]="accountLookupInProgress()"
        (saveAttempted)="onSaveAttempted()"
        (backRequested)="onBackRequested()"
      />
    }
  </div>

  <app-how-to-measure-dialog [open]="measureDialogOpen()" (closed)="closeMeasureDialog()" />
</section>
